import React from "react";

const ManageUsersTab = () => (
  <h2 className="mt-5">Manage Users</h2>
);

export default ManageUsersTab;
